import React, { useEffect, useState } from 'react'
import { styled } from 'linaria/react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import { Product_Page_Settings } from '../../CustomElements/elementTypes'
import { theme } from '../../Theme'
import FilterTags from '../../CategoryPage/Filters/FilterTags'
import MobileFilterDrawer from '../../CategoryPage/Filters/MobileFilterDrawer'
import { EXPECTED_PX_HEADER_HEIGHT } from '../Util/Constants'
import { useIntl } from '@jetshop/intl'
import Pagination from '../../CategoryPage/Widgets/Pagination'
import ProductSearchHitsList from './ProductHitsGrid'
import ProductListToolbar from '../../CategoryPage/Filters/ProductListToolbar'
import MobileFilterButtons from '../../CategoryPage/Filters/MobileFilterButtons'
import MobileFilterList, { getActiveFilterCount } from '../../CategoryPage/Filters/MobileFilterList'
import FilterPanelFooter from '../../CategoryPage/Filters/FilterPanelFooter'
import { useDigifiProductSearch } from '../../DigifiSearch/Hooks/useDigifiProductSearch'
import { DIGIFI_DEFAULT_PAGE_SIZE, DIGIFI_FILTER_FIELD_NAMES } from '../../DigifiSearch/constants'
import NextPrevPageMetaLinks from '../../CategoryPage/Widgets/NextPrevPageMetaLinks'
import SearchResultBannerSmall from '../Banners/SearchResultBannerSmall'
import FilterButtonsSkeleton from '../Skeletons/FilterButtonsSkeleton'

const ProductListWrapper = styled.div`
   background-color: ${theme.colors.white};

   .main-container {
      background-color: ${theme.colors.white};
      padding-top: 0.5rem;

      ${theme.above.lg} {
         padding-top: 3rem;
      }
   }

   ${theme.below.lg} {
      .filter-buttons {
         margin-bottom: 0.5rem;
      }
   }

   ${theme.below.md} {
      .content-container {
         background-color: ${theme.colors.white};
         margin-left: 0px;
      }
      .filter-buttons {
         padding-right: 1rem;
         padding-left: 1rem;
      }
   }

   .product-list-wrapper {
      height: 100%;
      background-color: ${theme.colors.white};
      border-top-left-radius: 32px 32px;
      padding-right: inherit;
      padding-right: 0.5rem;
      padding-left: 0.5rem;

      ${theme.above.md} {
         padding-right: 4rem;
         padding-left: 0rem;
      }
      ${theme.above.lg} {
         padding-left: 2.5rem;
      }
      ${theme.above.xl} {
         padding-left: 4rem;
      }
      ${theme.above.xxl} {
         padding-right: 8rem;
      }
   }

   .filter-tags-wrapper {
      background-color: ${theme.colors.white};
   }

   .product-toolbar-wrapper {
      position: relative;
      z-index: 2;
      padding-top: 0.5rem;
      padding-bottom: 0.75rem;
      ${theme.above.lg} {
         padding-left: 2.5rem;
         padding-right: 4rem;
      }
      ${theme.above.xl} {
         padding-left: 4rem;
      }
      ${theme.above.xxl} {
         padding-right: 8rem;
      }
   }

   .sticky-filter-menu-desktop {
      background-color: ${theme.colors.white};
      /* position: -webkit-sticky;
      position: sticky;
      top: ${EXPECTED_PX_HEADER_HEIGHT.md};
      z-index: 99;
      max-height: calc(100vh - ${EXPECTED_PX_HEADER_HEIGHT.md});
      overflow-y: auto;
      ${theme.above.xl} {
         top: ${EXPECTED_PX_HEADER_HEIGHT.lg};
         max-height: calc(100vh - ${EXPECTED_PX_HEADER_HEIGHT.lg});
      } */
   }

   .side-panel {
      z-index: 1;
      background-color: ${theme.colors.white};
      min-width: 280px;
   }

   .product-results-wrapper {
      flex: 3;
   }

   .price-accordion {
      border-bottom: 1px solid var(--color-separator) !important;
      margin-bottom: 1rem;
   }

   .sticky-filter-menu-desktop .accordion-wrapper:first-child .top-separator {
      border-top: 1px solid transparent !important;
   }
`

const SearchQueryProductList = ({ searchQuery }) => {
   const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
   const [getSetting, loadingSiteSettings] = useSiteSettingsQuery()
   const productSettings = getSetting(null, Product_Page_Settings)
   const [showSkeleton, setShowSkeleton] = useState(true);
   const t = useIntl();

   const {
      filters,
      products,
      facets,
      metaData,
      loading,
      updateFilters,
      resetTagFilters,
   } = useDigifiProductSearch(
      searchQuery && {
         fieldName: 'searchQuery',
         value: searchQuery,
      },
      true
   )

   useEffect(() => {
      setShowSkeleton(!searchQuery)
   }, [searchQuery])

   return (
      <React.Fragment>
         <NextPrevPageMetaLinks currentPage={metaData?.currentPage} totalPages={metaData?.totalPages} />
         <SearchResultBannerSmall
            searchValue={searchQuery}
            loading={loading}
            total={metaData?.totalCount}
         />
         <ProductListWrapper>
            <>
               <div
                  id="last-page-scroll-anchor"
                  className="main-container container-fluid pe-0 ps-0"
               >
                  <div className="content-container d-block d-lg-flex ml-128">
                     <div className="product-results-wrapper">
                        <div className="filter-tags-wrapper">
                           <div className="product-toolbar-wrapper d-none d-lg-block">
                              <ProductListToolbar
                                 filters={filters}
                                 facets={facets}
                                 metaData={metaData}
                                 updateFilters={updateFilters}
                              />
                           </div>
                           <div className="d-block d-lg-none">
                              {showSkeleton ? <FilterButtonsSkeleton /> : (
                              <MobileFilterButtons
                                 className="filter-buttons py-8"
                                 onFilterClick={() => setIsMobileFilterOpen(prev => !prev)}
                                 activeFilterCount={getActiveFilterCount(filters)}
                              />
                              )}
                           </div>
                           <FilterTags
                              filters={filters}
                              facets={facets}
                              visibleFilterTagsByFieldName={[
                                 DIGIFI_FILTER_FIELD_NAMES.PRICE,
                                 DIGIFI_FILTER_FIELD_NAMES.BRAND,
                                 DIGIFI_FILTER_FIELD_NAMES.PRODUCT_TYPE,
                                 DIGIFI_FILTER_FIELD_NAMES.STOCK_STATUS,
                                 DIGIFI_FILTER_FIELD_NAMES.PREBOOK,
                                 DIGIFI_FILTER_FIELD_NAMES.SORT_BY,
                              ]}
                              updateFilters={updateFilters}
                              onClearFilters={() =>
                                 resetTagFilters({
                                    filtersByFieldNameToPreserve: [],
                                 })
                              }
                           />
                        </div>

                        <div className="product-list-wrapper pb-32 pr-128">
                           <ProductSearchHitsList
                              products={products}
                              productSettings={productSettings}
                              loading={loading}
                              loadingCardsCount={DIGIFI_DEFAULT_PAGE_SIZE}
                           />
                           <div className="w-100 d-flex justify-content-center pt-32">
                              <Pagination
                                 metaData={metaData}
                                 updateFilters={updateFilters}
                              />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="d-block d-lg-none">
                  <MobileFilterDrawer
                     title={'Filter'}
                     isOpen={isMobileFilterOpen}
                     setIsOpen={setIsMobileFilterOpen}
                     footer={
                        <FilterPanelFooter
                           clearLabel={t('Clear all')}
                           clearAsButton
                           onClear={() =>
                              resetTagFilters({ filtersByFieldNameToPreserve: [] })
                           }
                           clearDisabled={
                              getActiveFilterCount(filters) === 0 &&
                              !filters?.some(f => f?.fieldName === DIGIFI_FILTER_FIELD_NAMES.SORT_BY)
                           }
                           onSubmit={() => setIsMobileFilterOpen(false)}
                           totalCount={metaData?.totalCount}
                        />
                     }
                  >
                     <MobileFilterList
                        filters={filters}
                        facets={facets}
                        updateFilters={updateFilters}
                     />
                  </MobileFilterDrawer>
               </div>
            </>
         </ProductListWrapper>
      </React.Fragment>
   )
}
export default SearchQueryProductList
